// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4l-0";
export var eligibilityCardNotEligible = "_4l-1";